import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeBonusModal, fetchBonus, openBonusModal } from "./store/bonusSlice";
import BonusDataTable from "./BonusDataTable";
import AddBonus from "./AddBonus";

const Bonus = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.bonusData || {});

  useEffect(() => {
    dispatch(fetchBonus());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Bonus "
            title="Dashboard"
            subtitle="Bonus"
            name="Import Bonus"
            onAddClick={() => dispatch(openBonusModal())}
          />

          <BonusDataTable data={data} loading={loading} />

          <AddBonus
            show={isModalOpen}
            onClose={() => dispatch(closeBonusModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Bonus;
